import { useCallback } from 'react';
import { Route, Switch } from 'react-router-dom';
import { BeaconMessageList } from './BeaconMessageList/BeaconMessageList';
import { BeaconMessageSetupPage } from './BeaconMessageSetupPage/BeaconMessageSetupPage';
import {
  useCreateBeaconMessageSetupFlowPageModel,
  useEditBeaconMessageSetupFlowPageModel,
  useSummaryBeaconMessageSetupFlowPageModel
} from './BeaconMessageSetupPage/BeaconMessageSetupPageModel';
import RouteWithPermission from 'components/RouteWithPermission/RouteWithPermission';
import { hasFuncs } from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import { ROUTE_PATH } from 'enum/RoutePath';

export const BeaconMessages: React.FC = () => {
  const renderBeaconMessageList = useCallback(() => {
    return <BeaconMessageList />;
  }, []);

  const renderBeaconMessageCreateForm = useCallback(() => {
    return (
      <BeaconMessageSetupPage
        useModel={useCreateBeaconMessageSetupFlowPageModel}
      />
    );
  }, []);

  const renderBeaconMessageEditForm = useCallback(() => {
    return (
      <BeaconMessageSetupPage
        useModel={useEditBeaconMessageSetupFlowPageModel}
      />
    );
  }, []);

  const renderBeaconMessageSummaryForm = useCallback(() => {
    return (
      <BeaconMessageSetupPage
        useModel={useSummaryBeaconMessageSetupFlowPageModel}
      />
    );
  }, []);

  return (
    <Switch>
      <RouteWithPermission
        permissionAware={hasFuncs(Permission.BEACON_MESSAGE_WRITE)}
        redirectPath={`/beacon-messages/new/${ROUTE_PATH.ERROR403}`}
        path={'/beacon-messages/new'}
        render={renderBeaconMessageCreateForm}
      />
      <RouteWithPermission
        permissionAware={hasFuncs(Permission.BEACON_MESSAGE_WRITE)}
        redirectPath={`/beacon-messages/:beaconMessageId/edit/${ROUTE_PATH.ERROR403}`}
        path={'/beacon-messages/:beaconMessageId/edit'}
        render={renderBeaconMessageEditForm}
      />
      <RouteWithPermission
        permissionAware={hasFuncs(Permission.BEACON_MESSAGE_READ)}
        redirectPath={`/beacon-messages/:beaconMessageId/summary/${ROUTE_PATH.ERROR403}`}
        path={'/beacon-messages/:beaconMessageId/summary'}
        render={renderBeaconMessageSummaryForm}
      />
      <Route render={renderBeaconMessageList} />
    </Switch>
  );
};
